import { Dialog, DialogContent } from '@mui/material'
import React from 'react'
import CreatEdit from './CreateEdit'
import  './vehicleVariant.css';

function VehicleVariantModel({handleClose,setNewValue,modelId}) {
  return (
    <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={true}
        onClose={handleClose}
      >
       
        <DialogContent className="modalContainer">
          <CreatEdit modelId={modelId}   setNewValue={setNewValue}  closeCreateEditForm={handleClose} vehichleVariantEditDatas={null} editStatus={false} />
        </DialogContent>
       
      </Dialog>
  )
}

export default VehicleVariantModel